<template>
  <!-- Contenedor Principal-->
  <b-container>
    <registrar-licencia-form v-on:form-licencia-close="cerrarModal($event)"></registrar-licencia-form>
  </b-container>
</template>

<script>
import swalerts from "@/helpers/swalerts";
import errorhandler from "@/helpers/errorhandler";
import LicenciaCargoPersonalSvc from '@/services/licenciacargopersonal'

import Multiselect from 'vue-multiselect'


import {mapGetters,mapActions} from 'vuex'

import RegistrarLicenciaForm from './RegistrarLicenciaForm.vue'
import SolicitudTableSelect from '../../common/SolicitudTableSelect.vue'

import { createHelpers } from 'vuex-map-fields';
import TablaLicencias from '../../common/TablaLicencias.vue';
import FormBuscarPersonal from '../../common/FormBuscarPersonal.vue';
import TablaCargoPersonal from '../../common/TablaCargoPersonal.vue'

const { mapFields: mapFormLicenciaFields } = createHelpers({
  getterType: 'FormLicenciaModule/getLicenciaField',
  mutationType: 'FormLicenciaModule/updateLicenciaField',
});
const { mapFields: mapFormBuscarPersonalFields } = createHelpers({
  getterType: 'FormBuscarPersonal/getFormBuscarPersonalField',
  mutationType: 'FormBuscarPersonal/updateFormBuscarPersonalField',
});
export default {
  name: 'RegistrarLicenciaSolicitud',
  mixins: [errorhandler, swalerts],
  components: { Multiselect, RegistrarLicenciaForm, SolicitudTableSelect, TablaLicencias, FormBuscarPersonal, TablaCargoPersonal },
  computed:{
    ...mapGetters([
      'getCantidadDias',
      'getUserInfo',
      'getUserName',
      'getEstablecimiento',
      'isInRoleAdmin',
      'isInRoleCoordinador',
      'isInRoleEstablecimiento']),
    ...mapFormLicenciaFields([
      "SolicitudSeleccionada",
      "SolicitudSeleccionada_Id"]),
    ...mapFormBuscarPersonalFields(['Personal_Id', 'ListaCargoPersonal'])
  },
  data() {
    return {
      disabled: false,
    }
  },
  watch: {
  },
  methods: {
    ...mapActions("SolicitudModule",["getSolicitud"]),
    cerrarModal(mensaje){
      if(mensaje){
        this.showSuccess(mensaje);
      }
      this.$router.push({ name: 'consultasolicitud', params: {  } });
    },
    activarBoton() {
      this.disabled = false;
    },
    desactivarBoton() {
      this.disabled = true;
    },
    exportarPdf() {
      var doc = new jsPDF();
      doc.text(`Licencias otorgadas: ${this.documento} ${this.nombre}`, 14, 16);

      var elem = document.getElementById("tablaLicencias");
      var res = doc.autoTableHtmlToJson(elem);
      //Ignorar columna 0 y 6 de la tabla
      res.columns.splice(6, 1);
      res.columns.splice(0, 1);
      res.data.forEach(e => {
        e.splice(6, 1);
        e.splice(0, 1);
      });
      doc.autoTable(res.columns, res.data, { startY: 20 });
      doc.save(`Licencias_${this.documento}.pdf`);
    },

    limitText (count) {
      return `y ${count} otros diagnósticos`
    },


    limpiar(){
      this.SolicitudSeleccionada = null;
      this.datosDocente = [];
      this.arregloLicencias = [];
      this.cantDiasSinTrabajar = 0;
    },
    porcentajeDias() {
      return this.diasSinTrabajar;
    },
    cantDiasAnio() {
      return 365;
    },

    nameWithLang({ Text }) {
      return `${Text}`;
    },
  },
  updated() {
  },
  mounted(){
    console.log('RegistrarLicenciaSolicitud mounted', this.$route.params);
    console.log('RegistrarLicenciaSolicitud mounted', this.$route.params.solicitud_id);
    this.Personal_Id = this.SolicitudSeleccionada.Personal_Id;
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/licencias/RegistrarLicenciaSolicitud.vue